import { Pipe, PipeTransform } from '@angular/core';
import { College } from '../classes/College/CollegeEnum';

@Pipe({
    name: 'extendedCollegeTerm'
})
export class ExtendedCollegeTermPipe implements PipeTransform {
    transform(term: any, collegeID?: number) {
        if (term == null) return '';

        let cyear = parseInt(term.CollegeSchoolYear,10);
        
        if (collegeID == null) {
            return (cyear + ' - ' + (cyear + 1) + ' Term ' + term.TermCode);
        }

        switch(collegeID) {
            case College.PolkStateCollege:
                // Polk State College - Unique situation for fall term. College years are 1 year ahead of Polk County Public Schools, so subtract one when displaying.
                return ((cyear - 1) + ' - ' + cyear + ' Term ' + term.TermCode);
            case College.SoutheasternUniversity:
            default:
                return (cyear + ' - ' + (cyear + 1) + ' Term ' + term.TermCode);
        }
    }
}


// WEBPACK FOOTER //
// ./src/pipes/extendedcollegeterm.pipe.ts